/** @format */

import { Navigate, useRoutes } from "react-router-dom";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
import LogoOnlyWithToken from "./layouts/LogoOnlyWithToken";
import { useSelector } from "react-redux";
//
import Login from "./pages/login/Login";
import Dashboard from "./pages/dashboard/Dashboard";
import UserList from "./pages/user/UserList";
import NotFound from "./pages/misc/Page404";
import UserCreate from "./pages/user/UserCreate";
import SignUp from "./pages/misc/SignUp";
import Number from "./pages/number/Number";
import NumberForm from "./pages/number/NumberForm";
import TemplateList from "./pages/template/TemplateList";
import TemplateEdit from "./pages/template/TemplateEdit";
import UserDetails from "./pages/user/UserDetails";
import UserEdit from "./pages/user/UserEdit";
import ProfileDetails from "./pages/user/ProfileDetails";
import ProfileEdit from "./pages/user/ProfileEdit";
import WabaMasterList from "./pages/wabaMaster/WabaMasterList";
import TemplateCreate from "./pages/template/TemplateCreate";
import Broadcast from "./pages/broadcast/Broadcast";
import BroadcastDetail from "./pages/broadcast/BroadcastDetail";
import BroadcastCreate from "./pages/broadcast/BroadcastCreate";
import BillingList from "./pages/billing/BillingList";
import BillingCreate from "./pages/billing/BillingCreate";
import BillingReviewOrder from "./pages/billing/BillingReviewOrder";
import ConfirmEmail from "./pages/misc/ConfirmEmail";
import ConnectWithFacebook from "./pages/misc/ConnectWithFacebook";
import PasswordForm from "./pages/misc/PasswordForm";
import Marketing from "./pages/marketing";
import CostMaster from "./pages/costMaster/CostMasterList";
import OTPManager from "./pages/OTPManagement/OTPManagementList";
import DocumentationAPI from "./pages/OTPManagement/DocumentationAPI";
import ApproveMaster from "./pages/approvalMaster/ApprovalMasterList";
// ----------------------------------------------------------------------

export default function Router() {
  let role = useSelector(({ auth }) => auth?.auth?.role);

  let routes = [];

  if (role === "SUPER_ADMIN" || role === "ADMIN") {
    routes = [
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "/", element: <Navigate to="/dashboard" /> },
          { path: "/dashboard", element: <Dashboard /> },

          { path: "/user", element: <UserList /> },
          { path: "/user/create", element: <UserCreate /> },
          { path: "/user/:userId/details", element: <UserDetails /> },
          { path: "/user/:userId/edit", element: <UserEdit /> },

          { path: "/waba-master", element: <WabaMasterList /> },

          { path: "/number", element: <Number /> },
          { path: "/number/manage/:waba_id/:id", element: <NumberForm /> },

          { path: "/template", element: <TemplateList /> },
          { path: "/template/create/:waba_id", element: <TemplateCreate /> },
          {
            path: "/template/manage/:waba_id/:id",
            element: <TemplateEdit />,
          },

          { path: "/profile", element: <ProfileDetails /> },
          { path: "/profile/edit", element: <ProfileEdit /> },

          { path: "/broadcast", element: <Broadcast /> },
          { path: "/marketing", element: <Marketing /> },
          { path: "/costMaster", element: <CostMaster /> },
          { path: "/otpManager", element: <OTPManager /> },
          { path: "/documentationapi", element: <DocumentationAPI /> },
          { path: "/approveMaster", element: <ApproveMaster /> },
          {
            path: "/broadcast/create/:waba_id",
            element: <BroadcastCreate />,
          },
          { path: "/broadcast/:id", element: <BroadcastDetail /> },

          { path: "/credits", element: <BillingList /> },
          { path: "/purchase/create/:waba_id", element: <BillingCreate /> },
          { path: "/purchase/review", element: <BillingReviewOrder /> },
        ],
      },
      {
        path: "/",
        element: <LogoOnlyWithToken />,
        children: [{ path: "/connectWFB", element: <ConnectWithFacebook /> }],
      },
      {
        path: "/",
        element: <LogoOnlyLayout />,
        children: [
          { path: "login", element: <Login /> },
          { path: "404", element: <NotFound /> },
          { path: "register", element: <SignUp /> },
          { path: "registration", element: <PasswordForm /> },
          { path: "confirm", element: <ConfirmEmail /> },
        ],
      },
    ];
  } else {
    routes = [
      {
        path: "/",
        element: <DashboardLayout />,
        children: [
          { path: "/", element: <Navigate to="/dashboard" /> },
          { path: "/dashboard", element: <Dashboard /> },

          { path: "/number", element: <Number /> },
          { path: "/number/manage/:waba_id/:id", element: <NumberForm /> },

          { path: "/template", element: <TemplateList /> },
          { path: "/template/create/:waba_id", element: <TemplateCreate /> },
          {
            path: "/template/manage/:waba_id/:id",
            element: <TemplateEdit />,
          },

          { path: "/broadcast", element: <Broadcast /> },
          { path: "/marketing", element: <Marketing /> },
          {
            path: "/broadcast/create/:waba_id",
            element: <BroadcastCreate />,
          },
          { path: "/broadcast/:id", element: <BroadcastDetail /> },

          { path: "/credits", element: <BillingList /> },
          { path: "/purchase/create/:waba_id", element: <BillingCreate /> },
          { path: "/purchase/review", element: <BillingReviewOrder /> },

          { path: "/profile", element: <ProfileDetails /> },
          { path: "/profile/edit", element: <ProfileEdit /> },
        ],
      },
      {
        path: "/",
        element: <LogoOnlyWithToken />,
        children: [{ path: "/connectWFB", element: <ConnectWithFacebook /> }],
      },
      {
        path: "/",
        element: <LogoOnlyLayout />,
        children: [
          { path: "login", element: <Login /> },
          { path: "404", element: <NotFound /> },
          { path: "register", element: <SignUp /> },
          { path: "registration", element: <PasswordForm /> },
          { path: "confirm", element: <ConfirmEmail /> },
        ],
      },
    ];
  }

  return useRoutes(routes);
}
